<template>

  <section class="confirmationbg">
    <b-container>
      <b-row>
        <b-col lg="6" md="6" sm="12" v-if="approvaldata.some((item: any) => item['IsApproved'] == 0)">

          <p class=" approvalheading">
            Approve {{ approvaldetails?.HeaderName }}
          </p>

          <!-- <p class="approvalcontent">
            A {{ approvaldetails?.ContentName }} approval is a process that
            enables authorized personnel to review and approve or reject
            {{ approvaldetails?.ContentName }}s before they are sent to
            suppliers.
          </p> -->
          <p class="approvalcontent">
            {{ approvaldetails?.ContentName }}
          </p>
        </b-col>
        <b-col lg="6" md="6" sm="12" v-else>
          <p class="approvalheading">
            Approval :
            {{ approvaldata["UserName"] }} - {{ approvaldata["RoleName"] }}
          </p>
          <p class="approvalcontent">
            A {{ approvaldetails?.ContentName }} approval is a process that
            enables authorized personnel to review and approve or reject
            {{ approvaldetails?.ContentName }}s before they are sent to
            suppliers.
          </p>
        </b-col>

        <b-col v-if="approvaldata.some((item: any) => item['IsApproved'] == 0)" lg="3" md="3" sm="12"
          class="d-flex align-items-center gap-3 justify-content-center my-3">
          <div class="pendingduration">
            <!-- <p class="light-txt">Pending for :</p>
            <p class="pendingtime">
              {{
                approvaltimerunner == "Invalid Date"
                  ? "00:00:00"
                  : approvaltimerunner
              }}
            </p> -->
          </div>
        </b-col>
        <b-col lg="3" md="3" sm="12" class="d-flex align-items-center justify-content-center">
          <div class="d-flex align-items-start gap-3 mt-4">
            <div>
              <Button label="Approve" class="approvebtn" @click="openpopup(1)" />
            </div>
            <div v-if="RejectBtnHide == true">
              <Button label="Reject" class="rejectbtn" @click="openpopup(3)" />
              <p class="rejectdesc">Decline with note</p>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <Dialog v-model:visible="popupdatas.approvepopup" modal header="" :style="{ width: '30rem' }"
      :breakpoints="{ '1199px': '75vw', '575px': '90vw' }" :closable="false">
      <template #header>
        <b-container fluid>
          <b-row>
            <b-col lg="12" md="12" class="d-flex flex-row-reverse">
              <i class="pi pi-times" style="color: #e1e1e1" @click="popupdatas.approvepopup = false"></i>
            </b-col>
          </b-row>
        </b-container>
      </template>
      <div class="approvaldetails">
        <img src="../../assets/Img/icons/info.svg"
          :class="popupdatas.Approvalstatus === 1 ? 'infoimg' : 'infoimgred'" />
        <p>
          <span class="approvedesc">You are about to {{ popupdatas.Approvename }} for</span><span class="approvenum">{{
            approvaldetails!["ApprovalCode"]
          }}</span>
        </p>
      </div>
      <div class="details-card d-flex align-items-center justify-content-between">
        <div>
          <div class="d-flex align-items-center gap-1">
            <i class="pi pi-calendar" style="color: #e1e1e1; margin-top: -3px"></i>
            <p class="approvaldate">{{ approvaldetails?.ApprovalDate }}</p>
          </div>
        </div>
        <p class="approvalamount">₹ {{ approvaldetails?.ApprovalPrice }}</p>
      </div>
      <b-row>
        <b-col>
          <div class="field">
            <CustomTextArea v-model="popupdatas.Remarks" :requiredIcon="false" placeholder=" " name="Remarks"
              id="Remarks" label="Remarks" :rules="{ required: false }" />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="d-flex flex-row-reverse mt-5">
            <Footer :label="popupdatas.Btnlabel" @save="$emit('Approve', popupdatas)"
              @cancel="popupdatas.approvepopup = false" />
          </div>
        </b-col>
      </b-row>
    </Dialog>
  </section>
  <ApprovedSuccessfully :visible="SuccessfullPopUp.accept" @ok="closetrigger()" />
  <DeclineSuccessfully :visible="SuccessfullPopUp.decline" @ok="closetrigger()" />
</template>

<script lang="ts">
import { defineComponent, ref, watch, onUnmounted } from "vue";
import CustomTextArea from "./TextArea.vue";
import Footer from "./Footer.vue";
import ApprovedSuccessfully from "./ApprovedSuccessfully.vue";
import DeclineSuccessfully from "./DeclineSuccessfully.vue";


interface ApprovalDetails {
  HeaderName?: string;
  ContentName?: string;
  ApprovalCode?: string;
  ApprovalDate?: string;
  ApprovalPrice?: number;
  CreatedAt?: string;
}
export default defineComponent({
  components: {
    CustomTextArea,
    Footer,
    ApprovedSuccessfully,
    DeclineSuccessfully,
  },
  props: {
    approvaldata: {
      type: Array as () => any[],
      default: () => [],
    },

    SuccessfullPopUp: {
      type: Object,
      default: {},
    },

    RejectBtnHide: {
      type: Boolean,
      default: true,
    },

    approvaldetails: {
      type: Object as () => ApprovalDetails,
      default: () => ({}),
    },
    lastindexvalue: {},
  },

  setup(props: any, { emit }) {
    let approvaltimerunner = ref("00:00:00");
    let SuccessfullPopUp = ref({
      accept: ref(false),
      decline: ref(false),
    });
    let popupdatas: any = ref({
      Approvalstatus: 0,
      Approvename: "",
      Btnlabel: "",
      Remarks: "",
      ApprovedAmount: 0,
      approvepopup: false,
    });

    watch(props.SuccessfullPopUp, (newValue: any) => {
      debugger;
      SuccessfullPopUp.value.accept = newValue.accept;
      SuccessfullPopUp.value.decline = newValue.decline;
    });

    function closetrigger() {
      SuccessfullPopUp.value.accept = false;
      SuccessfullPopUp.value.decline = false;
      popupdatas.value.approvepopup = false;

      emit("triggerDetails");
    }


    const updateTimers = () => {
      // alert(props.approvaldetails!["CreatedAt"]);
      // const createdAt = new Date(props.approvaldetails!["CreatedAt"]);
      const dateString = props.approvaldetails!["CreatedAt"];
      const [day, month, year] = dateString.split('-');
      const createdAt = new Date(`${year}-${month}-${day}`);
      const currentTime = new Date();
      const timeDifference = currentTime.getTime() - createdAt.getTime();

      // Calculate individual components
      const hours = Math.floor(timeDifference / (60 * 60 * 1000));
      const minutes = Math.floor(
        (timeDifference % (60 * 60 * 1000)) / (60 * 1000)
      );
      const seconds = Math.floor((timeDifference % (60 * 1000)) / 1000);

      // Format the time
      const formattedTime = `${String(hours).padStart(2, "0")}:${String(
        minutes
      ).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;

      approvaltimerunner.value = formattedTime;
    };

    const timerInterval = setInterval(updateTimers, 1000);

    onUnmounted(() => {
      clearInterval(timerInterval);
    });

    // const formattedTime = new Date(timeDifference).toLocaleTimeString("en-US", {
    //   hour12: false,
    //   timeZone: "UTC",
    //   hour: "2-digit",
    //   minute: "2-digit",
    //   second: "2-digit",
    // });

    // approvaltimerunner.value = formattedTime !== "Invalid Date" ? formattedTime : "00:00:00";

    function openpopup(Status) {
      debugger;

      popupdatas.value.Approvalstatus = Status;
      popupdatas.value.Approvename = Status == 1 ? "Approve" : "Decline";
      popupdatas.value.Btnlabel = Status == 1 ? "Confirm" : "Reject";

      popupdatas.value.Remarks = "";
      popupdatas.value.ApprovedAmount = props.approvaldetails?.ApprovalPrice || 0;
      popupdatas.value.approvepopup = true;
    }

    return {
      approvaltimerunner,
      closetrigger,
      SuccessfullPopUp,
      openpopup,
      popupdatas,

    };
  },
});
</script>

<style lang="scss" scoped>
@import "../../assets/variables.scss";

.confirmationbg {
  background-color: #161b22;
  padding: 10px 0;

  .container {
    margin: 0 auto;
  }
}

.approvalheading {
  color: #ffffff;
  font-size: 16px;
}

.approvalcontent {
  color: #999999;
  font-size: 13px;
}

.pendingduration {
  display: flex;
  align-items: center;
  gap: 3px;
  border-right: 1px solid #999999;
  width: max-content;
  padding-right: 10px;
  flex-wrap: wrap;
}

.pendingtime {
  color: #ffffff;
  font-size: 14px;
}

.rejectdesc {
  color: #999999;
  font-size: 10px;
}

.infoimg {
  filter: invert(70%) sepia(86%) saturate(495%) hue-rotate(68deg) brightness(81%) contrast(90%);
}

.infoimgred {
  filter: invert(18%) sepia(88%) saturate(7005%) hue-rotate(359deg) brightness(109%) contrast(124%);
}

.approvedesc {
  color: #999999;
}

.approvenum {
  color: #444444;
  font-weight: 500;
  margin-left: 5px;
}

.approvaldetails {
  display: flex;
  align-items: center;
  gap: 3px;
  width: max-content;
  margin: 0 auto;
}

.approvalcode {
  color: #999999;
  font-size: 13px;
}

.approvaldate {
  color: #444444;
  font-size: 14px;
  margin-top: -3px;
  font-weight: 500;
}

.approvalamount {
  color: #444444;
  font-size: 16px;
  font-weight: 600;
}

@media only screen and (max-width: 769px) {
  .pendingduration {
    border-right: none;
  }
}
</style>

<style lang="scss">
.approvebtn {
  background-color: #28c840 !important;
  border: none !important;
  padding: 8px 20px !important;

  .p-button-label {
    font-size: 12px !important;
  }
}

.approvebtn:hover {
  background-color: #28c840 !important;
  border: none !important;
  padding: 8px 20px !important;

  .p-button-label {
    font-size: 12px !important;
  }
}

.rejectbtn {
  background-color: #f85750 !important;
  border: none !important;
  padding: 8px 20px !important;

  .p-button-label {
    font-size: 12px !important;
  }
}

.rejectbtn:hover {
  background-color: #f85750 !important;
  border: none !important;
  padding: 8px 20px !important;

  .p-button-label {
    font-size: 12px !important;
  }
}
</style>
